import styled from '@emotion/styled';
import { Dropdown, Tooltip } from 'react-bootstrap';
import { COLORS, DEFAULT_THEME } from "../../constants/Theme";
import { ComponentZindex } from "../../constants/zindex";
import { BodyCaption, TitleSmall } from '../TypographyStyle';
export const GlobalContainer = styled.div `
	.global-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		width: 100%;
	}
	.component-container {
		flex: 1 1 0%;
	}
`;
//page spinner
export const LoaderWrapper = styled.div `
	width: 100%;
	height: 100vh;
	margin: 0;
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	align-content: center;
	.inner {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 40px;
		background-color: ${DEFAULT_THEME.colorsV2.surface.standard};
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
		border-radius: 4px;
		flex-direction: column;
	}

	.loader {
		width: 48px;
		height: 48px;
		border: 5px solid ${DEFAULT_THEME.colorsV2.stroke.brand};
		border-bottom-color: transparent;
		border-radius: 50%;
		display: inline-block;
		box-sizing: border-box;
		animation: rotation 1s linear infinite;
	}

	@keyframes rotation {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;
export const LoadingMessageWrapper = styled.div `
	margin-top: 16px;
`;
//bik-layout
export const BikLayoutContainer = styled.div `
	display: flex;
	flex-direction: row;
	${(props) => {
    if (props.type === 'overflow-within') {
        return `
      flex-grow: 0 !important;
      flex-shrink: 0 !important;
      flex-basis: calc(100vh - 56px) !important;
      overflow: scroll;
    `;
    }
    else {
        return 'flex: 1;';
    }
}}
	background-color: ${(props) => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : DEFAULT_THEME.colorsV2.surface.hovered; }};
	.pd-24 {
		padding: 24px;
	}
	.inner-wrapper {
		width: 100%;
	}
	.disabled--wrapper {
		position: fixed;
		opacity: 0.5;
		z-index: 4;
		height: 500vh;
		width: 100%;
		background-color: ${DEFAULT_THEME.colorsV2.surface.hovered};
	}
`;
//bik-
export const BikHeaderWrapper = styled.div `
	position: sticky;
	top: 0;
	z-index: 6;
`;
export const BikHeaderContainer = styled.div `
	background-color: ${DEFAULT_THEME.colorsV2.surface.standard};
	border-bottom: 0.5px solid #e0e0e0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	height: 56px;
	border-bottom-width: 0.5px;
	border-color: ${DEFAULT_THEME.colorsV2.background.inactive};
	padding: 16px;
	.cursor {
		cursor: pointer;
	}
	.brand {
		color: ${DEFAULT_THEME.colorsV2.stroke.brand};
	}
	.row--flex {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
	}
`;
//profile
export const MenuInnerContainer = styled.div `
	z-index: 1;
	padding-top: 16px;
	padding: 8px;
	display: flex;
	flex-direction: column;
	width: 291px;
	.divider {
		border: 1px solid ${DEFAULT_THEME.colorsV2.background.inactive};
		margin: 0px 4px;
	}
	.logout--container {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 8px;
		gap: 8px;
		border-radius: 8px;
		cursor: pointer;
		margin-top: 10px;
		&:hover {
			background-color: ${DEFAULT_THEME.colorsV2.background.negative.light};
		}
	}
`;
export const ProfileDropdownToggleContainer = styled(Dropdown.Toggle) `
	border-radius: 4px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 6px 8px;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
   .inner
`;
export const ProfileDropdownInnerContainer = styled.div `
	display: flex;
	flex-direction: row;
	gap: 0px 8px;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	padding: 6px;
	background-color: ${(props) => props.isDropdownOpen && DEFAULT_THEME.colorsV2.background.brandLight};
	&:hover {
		background-color: ${(props) => props.isDropdownOpen
    ? DEFAULT_THEME.colorsV2.background.brandLight
    : DEFAULT_THEME.colorsV2.surface.hovered};
	}
`;
export const UserNameTitleSmall = styled(TitleSmall) `
	white-space: nowrap;
	max-width: 161px;
	overflow: hidden;
	text-overflow: ellipsis;
`;
export const UserAvatarContainer = styled.div `
	width: 32px;
	height: 32px;
	border-radius: 50%;
	.avatar--container {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		background-color: ${DEFAULT_THEME.colorsV2.background.inverse};
		border-radius: 50%;
		width: 32px;
		height: 32px;
	}
	img {
		object-fit: contain;
		height: 100%;
		width: 100%;
	}
`;
export const StyledTooltip = styled(Tooltip) `
	.tooltip-inner {
		background-color: ${DEFAULT_THEME.colorsV2.surface.standard};
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
	}
	.tooltip-arrow::before {
		display: none;
	}
`;
export const UserInfoContainer = styled.div `
	background-color: ${DEFAULT_THEME.colorsV2.surface.standard};
	min-width: 188px;
	display: flex;
	flex-direction: row;
	border-top-right-radius: 4px;
	border-top-left-radius: 4px;
	margin-bottom: 8px;
	padding: 8px;
	border-radius: 8px;
	cursor: pointer;
	&:hover {
		background: ${DEFAULT_THEME.colorsV2.surface.hovered};
	}
`;
export const StatusContainer = styled.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 4px;
	.availability--container {
		border-width: 1px;
		margin-right: 4px;
		height: 6px;
		width: 6px;
		border-style: solid;
		border-color: ${(props) => props.isAvailable
    ? DEFAULT_THEME.colorsV2.background.positive.vibrant
    : DEFAULT_THEME.colorsV2.content.secondary};
		background-color: ${(props) => props.isAvailable
    ? DEFAULT_THEME.colorsV2.background.positive.vibrant
    : DEFAULT_THEME.colorsV2.surface.standard};
		border-radius: 4px;
	}
`;
export const UserStatusContainer = styled.div `
	display: flex;
	flex-direction: column;
	margin-left: 16px;
	justify-content: space-between;
	justify-content: flex-start;
`;
export const StyledBodyCaption = styled(BodyCaption) `
	color: ${(props) => props.isAvailable
    ? DEFAULT_THEME.colorsV2.background.positive.vibrant
    : DEFAULT_THEME.colorsV2.content.secondary};
`;
//feature modal
export const FeatureModalContainer = styled.div `
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-end;
	position: fixed;
	bottom: 0;
	width: fill-available;
	height: ${(props) => (props.resetHeight ? 'fit-content' : '650px')};
	padding: 24px;
	z-index: ${(props) => props.zIndex ? props.zIndex : ComponentZindex.FEATURE_MODAL};
	background: linear-gradient(
		180deg,
		rgba(255, 255, 255, 0) 0%,
		#ffffff 71.35%
	);
	filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.12));
	.cross-button {
		width: 40px;
		height: 40px;
		background-color: ${COLORS.scrim.standard};
		border-radius: 50%;
		position: fixed;
		margin: auto;
		bottom: 164px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid ${COLORS.stroke.primary};
		cursor: pointer;
		z-index: ${(props) => (props.zIndex ? props.zIndex : 5)};
	}
`;
export const InnerModalContainer = styled.div `
	width: 100%;
	height: 132px;
	background: ${COLORS.background.inverse};
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
	border-radius: 8px;

	.mt-8 {
		margin-top: 9px;
	}
	.content-layout {
		padding: 24px;
		gap: 8px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}

	.cta-buttons {
		display: flex;
		align-items: center;
		gap: 16px;
	}
	.title-color {
		color: ${COLORS.surface.subdued};
	}
	.subtitle-color {
		color: ${COLORS.content.secondaryInverse};
	}
`;
export const RelativeModalContainer = styled.div `
	width: fit-content;
	border-radius: 8px;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
	position: relative;

	.cross-container {
		position: absolute;
		display: flex;
		width: 100%;
		justify-content: flex-end;
		padding: 12px;
		cursor: pointer;
	}
	.demo-container {
		padding: 18px 24px;
		border: 1px solid var(--stroke-color-stroke-negative-light-alt, #ffced4);
		background: var(--surface-color-background-negative-light, #ffebef);
		gap: 8px;
		height: 132px;
		max-width: 494px;
		border-radius: 8px;
	}
	.content-layout {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		height: 220px;
	}
	.left-content {
		width: 261px;
		img {
			height: 100%;
			width: 100%;
			object-fit: contain;
		}
	}
	.right-content {
		padding: 36px 24px;
		height: 100%;
		background-color: white;
		> * {
			margin-top: 8px;
		}
	}
	.cta-button-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		gap: 16px;
		margin-top: 16px;
	}
`;
export const FeatureModalV2Container = styled.div `
	.top-feature-content {
		max-height: 285px;
		img {
			height: 100%;
			width: 100%;
			object-fit: contain;
		}
	}
	.mt-8 {
		margin-top: 8px;
	}
	.bottom-feature-content {
		padding: 36px 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 16px;
	}
	.cta-buttons {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 16px;
		justify-content: center;
		margin-top: 8px;
	}
	.title-class {
		max-width: 500px;
	}
	.text-align-center {
		text-align: center;
	}
`;
//# sourceMappingURL=CommonStyles.js.map